const env = 'prod';
const backendUrl = `https://456b9ows62.execute-api.sa-east-1.amazonaws.com/prod/api/v1/graphql`;
const frontendUrl = `https://devolve.cliqueretire.com.br`;
const mapsKey = `AIzaSyCllEjIuKjnbXBGeGttSZsp-RdmnXhoklY`;
const exportOrdersUrl = `https://456b9ows62.execute-api.sa-east-1.amazonaws.com/prod/api/v1/exportOrdersCsv`;
const fileUploadUrl = `https://456b9ows62.execute-api.sa-east-1.amazonaws.com/prod/api/v1/fileUpload`;
/* const mapsKey = `AIzaSyBePXPQ5-Pm4GIx7tDc8xHBNpL53hTQNmw`; */

export default {
  env,
  backendUrl,
  frontendUrl,
  mapsKey,
  exportOrdersUrl,
  fileUploadUrl,
};
